import moment from 'moment';
import DTO from './DTO';
import DtoType from './converters/DtoType';
import ParkingMeterDTO from './ParkingMeterDTO';
import UserDTO from './UserDTO';
import CommandTemplateDTO from './CommandTemplateDTO';

class HostCommandDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'id',
      },
      {
        name: 'name',
        type: String,
        validators: [],
        labelKey: 'name',
      },
      {
        name: 'user_id',
        type: String,
        validators: [],
        labelKey: 'user_id',
      },
      {
        name: 'host_id',
        type: String,
        validators: [],
        labelKey: 'host_id',
      },
      {
        name: 'command_id',
        type: String,
        validators: [],
        labelKey: 'command_id',
      },
      {
        name: 'created_at',
        type: moment,
        validators: [],
        labelKey: 'created_at',
      },
      {
        name: 'expiration_at',
        type: moment,
        validators: [],
        labelKey: 'expiration_at',
      },
      {
        name: 'executed_at',
        type: moment,
        validators: [],
        labelKey: 'executed_at',
        couldBeNull: true,
      },
      {
        name: 'status',
        type: Number,
        validators: [],
        labelKey: 'status',
      },
      {
        name: 'host',
        type: DtoType(ParkingMeterDTO),
        validators: [],
        labelKey: 'host',
      },
      {
        name: 'user',
        type: DtoType(UserDTO),
        validators: [],
        labelKey: 'user',
      },
      {
        name: 'command_template',
        type: DtoType(CommandTemplateDTO),
        validators: [],
        labelKey: 'command_template',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default HostCommandDTO;
